import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import IPosModal from '../../IPosModal';
import FormattedPrice from "../../components/FormattedPrice";
import {
  clearOrder,
  setOrderDateTime,
  setOrderType,
} from "../../redux/actions/orderActions";
import ValueCardBenefits from './ValueCardBenefits';
import {loadValueCardInformation} from '../../redux/actions/valueCardAction';

import {
  currentDeliveryItem,
  orderSubTotal,
  orderTotal,
} from "../../redux/selectors/order";
import { setDeliveryType } from "../../redux/actions/baseActions";
import { clearClientInfo } from "../../redux/actions/clientActions";

import './ValueCardInfo.scss';

const ValueCardInfo = ({
  t,
  loadValueCardInformation,
  cardNumber,
  setCardNumber,
  selectedBenefits,
  setSelectedBenefits,
  valuecardClientInfo,
  setValuecardClientInfo,
  nextButtonState,
  setNextButtonState,
  onClickOk
}) => {

  const handleChange = (e) => {
    const { value } = e.currentTarget;
    setCardNumber(value);
  };

  const onSelectedBenefits = (benefit) => {
    let findBenefits = selectedBenefits.filter((i) => i.promoId !== benefit.promoId);
    if (findBenefits.length != selectedBenefits.length) {
      setSelectedBenefits(findBenefits);
    } else {
      setSelectedBenefits([...selectedBenefits, benefit]);
    }
  };

  const onSearchValueCardClient = async () => {
    const res = await loadValueCardInformation(cardNumber);
    if (!res || (res && (res.common.isError || res == ''))) {
      showAlert(res.common.message);
    }
    else
    {      
      setValuecardClientInfo(res);
      setNextButtonState(true);
    }
  };

  const showAlert = (message) => {
    IPosModal.alert({
      title: t('add_item_modal.errors.title'),
      message: message,
      okButtonText: t('buttons.ok'),
      cancelButtonText: t('buttons.cancel'),
      onOk: () => {
      }
    });
  };

  return (
    <div className="nav-side-menu valuecart">
      <div className="valuecart-container">
        {!nextButtonState && (
          <h3 className="headline">
            <span>{t("valuecard_info.title")}</span>
          </h3>
        )}

        {nextButtonState && valuecardClientInfo && (
          <h3 className="headline">
            <span>
              {t("valuecard_info.hello")} {valuecardClientInfo.memberFullName}
            </span>
          </h3>
        )}

        {!nextButtonState && (
          <div className="search-block">
            {/* {cardNumber.length > 0 && (
          <div className="search-client-btn" onClick={onSearchValueCardClient}>
            <FontAwesomeIcon icon="search" />
          </div>
        )} */}
            <input
              className="search-client-input"
              type="number"
              placeholder={t("valuecard_info.card-number")}
              onChange={handleChange}
              value={cardNumber}
              autoComplete={"off"}
            />
            {cardNumber.length > 0 && (
              <div
                className="clear-search"
                onClick={() => {
                  setCardNumber("");
                }}
              >
                <FontAwesomeIcon icon="times" />
              </div>
            )}
          </div>
        )}
        {nextButtonState && valuecardClientInfo && (
          <div className="valuecard_info">
            <div className="valuecard-client-info">
              {/* <div className="client-block">
              <div className="client-name-label">
                {t("valuecard_info.client-name")}
              </div>
              <div className="client-name">
                {valuecardClientInfo.memberFullName}
              </div>
            </div> */}
              <div className="client-block">
                <div className="points-label">
                  {" "}
                  {t("valuecard_info.points")}{" "}
                </div>
                <div className="points-value">
                  {valuecardClientInfo.totalPoints}
                </div>
              </div>
              <div className="client-block">
                <div className="budget-left-label">
                  {t("valuecard_info.budget-left")}
                </div>
                <div className="budget-left-value">
                  {valuecardClientInfo.prepaidBalance}
                </div>
              </div>
            </div>

            <div className="valuecard-header">
              <div className="header-title">
                {t("valuecard_info.benefits-title")}
              </div>
              <div className="header-description">
                {t("valuecard_info.benefits-description")}
              </div>
            </div>
            <div className="valuecard-benefits">
              {valuecardClientInfo.userBenefits.map((benefit) => (
                <ValueCardBenefits
                  key={benefit.promoId}
                  benefit={benefit}
                  selectedBenefits={selectedBenefits}
                  onSelectedBenefits={onSelectedBenefits}
                />
              ))}
            </div>
          </div>
        )}
      </div>
      {!nextButtonState && (
        <div
          className={`add-valuecart-button ${
            cardNumber.length === 0 ? "disabled" : ""
          }`}
          onClick={onSearchValueCardClient}
        >
          {t("valuecard_info.next")}
        </div>
      )}
      {nextButtonState && (
        <div
          className={`add-valuecart-button ${
            !valuecardClientInfo ? "disabled" : ""
          }`}
          onClick={onClickOk}
        >
          {t("valuecard_info.OK")}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    orderItems,
    branchInfo,
    menuItemTypes,
    currentLanguageId,
    orderType,
    orderDateTime,
    currentDeliveryType,
  } = state;

  return {
    orderItems,
    branchInfo,
    menuItemTypes,
    currentLanguageId,
    orderType,
    orderDateTime,
    currentDeliveryType,
    totalAmount: orderTotal(state),
    subtotalAmount: orderSubTotal(state),
    deliveryItem: currentDeliveryItem(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clearOrder,
      setOrderType,
      setOrderDateTime,
      setDeliveryType,
      clearClientInfo,
      loadValueCardInformation
    },
    dispatch
  );

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ValueCardInfo)
);
